"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = void 0;
exports.events = [
    'onBoot',
    'onDestroy',
    'onDragEnd',
    'onDragEnter',
    'onDrag',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onGameObjectDown',
    'onGameObjectDragEnd',
    'onGameObjectDragEnter',
    'onGameObjectDrag',
    'onGameObjectDragLeave',
    'onGameObjectDragOver',
    'onGameObjectDragStart',
    'onGameObjectDrop',
    'onGameObjectMove',
    'onGameObjectOut',
    'onGameObjectOver',
    'onGameObjectPointerDown',
    'onGameObjectPointerMove',
    'onGameObjectPointerOut',
    'onGameObjectPointerOver',
    'onGameObjectPointerUp',
    'onGameObjectPointerWheel',
    'onGameObjectUp',
    'onGameObjectWheel',
    'onGameOut',
    'onGameOver',
    'onManagerBoot',
    'onManagerProcess',
    'onManagerUpdate',
    'onPointerLockChange',
    'onPointerDown',
    'onPointerDownOutside',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onPointerUpOutside',
    'onPointerWheel',
    'onPreUpdate',
    'onShutdown',
    'onStart',
    'onUpdate',
].reduce(function (map, event) {
    map[event] = 1;
    return map;
}, {});
//# sourceMappingURL=events.js.map